<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex v-if="transactionObj && stripeObjChecked" xs12 sm8 md8 lg8>
          <v-card v-if="!stripeObj" class="elevation-1">
<!--                                <v-btn @click="onlogout">logout</v-btn>-->
            <v-img
                class="mt-6"
                height="50"
                contain
                src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2Fstripe_logo_credit_card.png?alt=media&token=2e139d67-0ac6-4cf6-99ee-041e0560beb3"
            ></v-img>
            <v-card-title>Enter Card Details</v-card-title>
            <v-card-text>
              <stripe-element-card
                  ref="elementRef"
                  :pk="publishableKey"
                  @token="tokenCreated"
                  @element-change="cardStatus"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!inputValid" class="mt-3 blue" block dark @click="submit">Charge Card</v-btn>
            </v-card-actions>
            <v-card-actions class="mb-3">
              <v-spacer></v-spacer>
              <v-btn block text @click="$router.push('/' +publicListingId + '/invoice/' + invoiceId)">cancel</v-btn>
            </v-card-actions>
            <v-card-subtitle>Payment security provided by <a href="https://stripe.com/en-ca/privacy" class="black--text">Stripe.</a>
            </v-card-subtitle>
          </v-card>
          <v-card v-else >
            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-item>
                    <v-card
                        height="220"
                        @click="openChargeCardDialog"
                        class="elevation-12 light-blue white--text"
                        style="background:linear-gradient(135deg, #13f1fc 0%,#099ce7 100%);"
                    >
                      <v-card-title>
                          <v-icon class="mr-2 white--text">credit_card</v-icon>
                          {{stripeObj.card.brand}}
                      </v-card-title>
                      <v-card-subtitle class="display-1 white--text">****{{stripeObj.card.last4}}</v-card-subtitle>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-card-subtitle class="headline white--text">
                          Expires: {{stripeObj.card.exp_month}}/{{stripeObj.card.exp_year}}
                        </v-card-subtitle>
                      </v-card-actions>
                      </v-card>
                  </v-item>
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-item>
                    <v-card
                        height="100"
                        @click="stripeObj = null"
                    >
                      <v-card-title><v-icon>add</v-icon><v-icon class="mr-2">credit_card</v-icon>
                        Add new card
                      </v-card-title>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-subtitle>Payment security provided by <a href="https://stripe.com/en-ca/privacy">Stripe.</a>
            </v-card-subtitle>
          </v-card>
        </v-flex>
        <v-flex v-if="!transactionObj" xs12 sm8 md8 lg8>
          <v-card  class="elevation-1">
            <v-card-title>Transaction Failed</v-card-title>
            <v-card-text>
             <v-icon class="red--text">cancel</v-icon>Go back to invoice to begin payment process.
            </v-card-text>
            <v-card-actions>
              <v-btn block outlined @click="$router.push('/' +publicListingId + '/invoice/' + invoiceId)">back to Invoice</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="chargeCardDialog"
              persistent
              max-width="300"
    >
      <v-card>
        <v-card-title v-if="transactionObj" class="text-h5">
          <v-icon>receipt</v-icon> {{transactionObj.paymentInfo.splitTitle}}
        </v-card-title>
        <v-card-text v-if="transactionObj" >
          <div class="headline">
            <v-icon>attach_money</v-icon> {{transactionObj.paymentInfo.splitAmount}}
          </div>
          <div>
            Will be charged on
          </div>
          <div v-if="stripeObj">
            {{stripeObj.card.brand}} ****{{stripeObj.card.last4}} Expires: {{stripeObj.card.exp_month}}/{{stripeObj.card.exp_year}}
          </div>
        </v-card-text>

        <v-card-text v-if="transactionObj">
          <div>
            <v-btn class="green" dark block @click="chargeCardOnFile">Charge card</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
              block
              text
              @click="chargeCardDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>

import { StripeElementCard } from '@vue-stripe/vue-stripe';
import {doc, onSnapshot} from "firebase/firestore";
export default {
  components: {
    StripeElementCard,
  },
  props: ['uid', 'publicListingId', 'invoiceId'],
  data () {
    return {
      // publishableKey: 'pk_test_VSiz0KZwXiOcCozNlMssyig5',
      stripeObjChecked: false,
      publishableKey: 'pk_live_IhMPCQ7scj4IOyljoFEkFxmv',
      token: null,
      inputValid: false,
      invoiceObj: null,
      stripeObj: null,
      chargeCardDialog: false,
      clientProfile: null
    };
  },
  created () {
    if (this.transactionObj) {
      this.invoiceObj = this.transactionObj.invoiceObj
    }
    console.log(this.transactionObj)
    let db = this.$store.state.db
    let uid = this.uid
    // console.log(this.uid)
    let clientRef = doc(db, 'customers', uid)
    onSnapshot(clientRef, res => {
      //console.log(res.data)
      if (res.data) {
        let data = res.data()
        this.clientProfile = data
        //console.log(res.data())
        if(data.stripeObj) {
          // route to booking
        }
      }
      this.stripeObjChecked = true
    })
  },
  computed: {
    transactionObj () {
      let obj = this.$store.getters.transactionObj
      return obj
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onlogout () {
      this.$store.dispatch('logout')
    },
    chargeCardOnFile () {
      //console.log(this.stripeObj)
      let payload = this.transactionObj
      payload.stripeObj = this.stripeObj
      payload.chargeType = 'cardOnFile'
      this.chargeCardDialog = false
      this.$store.dispatch('chargeCardOnFile', payload)
    },
    openChargeCardDialog () {
      this.chargeCardDialog = true
    },
    submit () {
      // this will trigger the process
      this.$refs.elementRef.submit();
    },
    tokenCreated (token) {
      // console.log(this.user);
      let transObj = this.transactionObj
      transObj.invoiceObj.contactName = this.user.name
      transObj.invoiceObj.contactPhoneNumber = this.user.phoneNumber
      // console.log(transObj)
      let chargeObject = {chargeToken: token, ...transObj, chargeType: 'newCard'}
      this.$store.dispatch('newCardPaymentMade', chargeObject)
    },
    cardStatus (status) {
      this.inputValid = !!status.complete
    }
  }
};
</script>
